import { render } from "./estimate_body_main.vue?vue&type=template&id=67f2a2fa"
import script from "./estimate_body_main.vue?vue&type=script&lang=js"
export * from "./estimate_body_main.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__